const DEFAULT_SIZE_DROPDOWN_I18N = {
  label_size: 'Size',
  size_s_title: 'Cabin',
  size_s_subtitle: 'Ryanair Priority, Wizz Air, LOT, Lufthansa',
  size_s_dimensions: '55×40×20',
  size_s_volume: '38L',
  size_m_title: 'Medium',
  size_m_subtitle: 'Checked baggage (all airlines)',
  size_m_dimensions: '66×45×26',
  size_m_volume: '65L',
  size_l_title: 'Large',
  size_l_subtitle: 'Checked baggage / family',
  size_l_dimensions: '76×50×30',
  size_l_volume: '98L',
};

class LinkedProductVariants extends HTMLElement {
  constructor() {
    super();
    this.sku = this.dataset.sku;
    this.currentHandle = this.dataset.handle;
    this.collection = this.dataset.collection;
    if (this.collection === 'all' || this.collection === 'frontpage') {
      this.collection = '';
    }
    
    this.container = this.querySelector('[data-linked-variants-container]');
    
    if (!this.sku || !this.container) return;

    // Pobierz model (część przed pierwszym myślnikiem)
    this.model = this.sku.split('-')[0];
  }

  connectedCallback() {
    // Odczekaj moment, aby upewnić się, że dzieci tagu (np. skrypt JS) zostały w pełni sparsowane
    setTimeout(() => {
      this.init();
    }, 0);
  }

  readSizeDropdownI18n() {
    const el = this.querySelector('[data-linked-variants-i18n]');
    if (!el || !el.textContent) return { ...DEFAULT_SIZE_DROPDOWN_I18N };
    try {
      const parsed = JSON.parse(el.textContent.trim());
      return { ...DEFAULT_SIZE_DROPDOWN_I18N, ...parsed };
    } catch (e) {
      return { ...DEFAULT_SIZE_DROPDOWN_I18N };
    }
  }

  sizeTitleForCode(size) {
    const s = String(size).toUpperCase();
    const i = this.i18n;
    if (s === 'S' || s === '20') return i.size_s_title;
    if (s === 'M' || s === '24') return i.size_m_title;
    if (s === 'L' || s === '28') return i.size_l_title;
    if (s === 'XS' || s === '16' || s === '18') return 'Mini';
    if (s === 'XL' || s === '32') return 'Bardzo duża';
    if (s.includes('SET') || s.includes('KPL') || s.includes('ZESTAW')) return 'Zestaw';
    return size;
  }

  normalizeSizeCode(size) {
    const s = String(size).toUpperCase();
    if (s === 'S' || s === '20') return 's';
    if (s === 'M' || s === '24') return 'm';
    if (s === 'L' || s === '28') return 'l';
    if (s === 'XS' || s === '16' || s === '18') return 'xs';
    if (s === 'XL' || s === '32') return 'xl';
    return s.toLowerCase();
  }

  getBadgeText(size) {
    const s = String(size).toUpperCase();
    if (this.isSet(s)) return 'Z';
    if (s === '16' || s === '18') return 'XS';
    return s;
  }

  isSet(size) {
    const s = String(size).toUpperCase();
    return s.includes('SET') || s.includes('KPL') || s.includes('ZESTAW');
  }

  isRealSize(size) {
    // Realny rozmiar produktu (np. walizka). NIE komplet (KPL/SET) i NIE marker typu produktu
    // jak BACKPACK / CB (crossbody) / BC (kuferek) / OS / ONE_SIZE.
    // Jeśli pojawi się nowy rozmiar w SKU, dopisz go tutaj.
    const s = String(size).toUpperCase().trim();
    const STANDARD_SIZES = ['XS', 'S', 'M', 'L', 'XL', '16', '18', '20', '24', '28', '32'];
    return STANDARD_SIZES.includes(s);
  }

  async init() {
    try {
      // === 1. Czytamy ręczne metafieldsy (zawsze) ===
      let allManualProducts = [];
      let hasManualSizes = false;
      let hasManualColors = false;
      let autoSizesEnabled = true;

      const manualScript = this.querySelector('[data-manual-variants]');
      if (manualScript) {
        try {
          const parsed = JSON.parse(manualScript.textContent.trim());
          // Wyciągamy __meta obiekt (pierwszy element tablicy z flagami)
          const metaObj = parsed.find(p => p.__meta === true);
          if (metaObj) {
            hasManualSizes = !!metaObj.has_manual_sizes;
            hasManualColors = !!metaObj.has_manual_colors;
            if (typeof metaObj.auto_sizes_enabled === 'boolean') {
              autoSizesEnabled = metaObj.auto_sizes_enabled;
            }
          }
          // Filtrujemy produkty (bez __meta)
          allManualProducts = parsed.filter(p => !p.__meta);
          console.log(`[Linked Variants] Manual JSON: ${allManualProducts.length} products | has_manual_sizes=${hasManualSizes} | has_manual_colors=${hasManualColors} | auto_sizes_enabled=${autoSizesEnabled}`);
        } catch(e) {
          console.error('[Linked Variants] Error parsing manual variants JSON', e);
        }
      }
      this.autoSizesEnabled = autoSizesEnabled;

      // === 2. Jeśli brakuje ręcznych rozmiarów lub kolorów – uruchamiamy automat dla brakujących ===
      let autoProducts = [];
      const needAutoSizes = !hasManualSizes && autoSizesEnabled;
      const needAutoColors = !hasManualColors;

      if (needAutoSizes || needAutoColors) {
        console.log(`[Linked Variants] Auto-fetch needed: sizes=${needAutoSizes} colors=${needAutoColors}`);
        try {
          let rawText = null;
          if (this.collection) {
            const collRes = await fetch(`/collections/${this.collection}?view=variants.json`);
            if (collRes.ok) rawText = await collRes.text();
          }
          if (!rawText) {
            const searchRes = await fetch(`/search?view=variants.json&type=product&q=${this.model}*`);
            if (searchRes.ok) rawText = await searchRes.text();
          }
          if (rawText) {
            const jsonStr = rawText.substring(rawText.indexOf('['), rawText.lastIndexOf(']') + 1);
            const fetched = JSON.parse(jsonStr);
            // Filtrujemy tylko produkty tego samego modelu
            autoProducts = fetched.filter(p => p.sku && p.sku.split('-')[0] === this.model && p.size);
            console.log(`[Linked Variants] Auto-fetched ${autoProducts.length} products from API`);
          }
        } catch(e) {
          console.warn('[Linked Variants] Auto-fetch failed:', e);
        }
      }

      // === 3. Budujemy ostateczną listę produktów ===
      // - Produkty manual-size: zawsze dodajemy (jeśli hasManualSizes)
      // - Produkty manual-color: zawsze dodajemy (jeśli hasManualColors)
      // - Produkty auto: dodajemy tylko dla brakujących wymiarów (size lub color)
      let products = [...allManualProducts];
      const currentProduct = products.find(p => p.is_current);
      const currentProductColorCode = currentProduct ? (currentProduct.color_code || currentProduct.color) : null;
      // Klasa rozmiaru bieżącego produktu. Auto-rozmiary łączymy tylko w obrębie tej samej klasy:
      //  - realny rozmiar (XS/S/M/L/XL, 20/24/28...) ↔ inne realne rozmiary,
      //  - komplet (KPL/SET/ZESTAW) ↔ inne komplety.
      // Dzięki temu do walizki nie dopisze się komplet, a do plecaka/saszetki (jeden „rozmiar": BACKPACK/CB) nic.
      const currentIsRealSize = currentProduct ? this.isRealSize(currentProduct.size) : false;
      const currentIsSet = currentProduct ? this.isSet(currentProduct.size) : false;
      // Token rozmiaru/typu bieżącego produktu (np. "M", "BACKPACK", "CB"). Auto-KOLORY zbieramy
      // tylko dla TEGO SAMEGO typu produktu w innych kolorach — żeby do plecaka nie trafiła saszetka (CB).
      const currentSizeToken = currentProduct ? String(currentProduct.size).toUpperCase().trim() : null;

      if (needAutoSizes || needAutoColors) {
        for (const ap of autoProducts) {
          const apColorCode = ap.color_code || ap.color;
          // Dodajemy autoProdukt jeśli:
          // - Potrzebujemy auto-rozmiarów I ten produkt ma kolor bieżącego produktu I jest tej samej klasy rozmiaru
          // - Potrzebujemy auto-kolorów I ten produkt nie jest już w ręcznych kolorach
          const isAlreadyManualColor = allManualProducts.some(m => m.is_manual_color && m.color_code === apColorCode);
          const isAlreadyManualSize = allManualProducts.some(m => m.is_manual_size && m.handle === ap.handle);
          const sameSizeClass = (currentIsRealSize && this.isRealSize(ap.size)) || (currentIsSet && this.isSet(ap.size));
          const apSizeToken = String(ap.size).toUpperCase().trim();

          if (needAutoSizes && sameSizeClass && !isAlreadyManualSize && apColorCode === currentProductColorCode) {
            if (!products.some(p => p.handle === ap.handle)) {
              products.push({ ...ap, is_auto_size: true });
            }
          }

          // Auto-kolory: ten sam model I ten sam token rozmiaru/typu (inny kolor) = ten sam produkt w innej barwie.
          // Bez tego do plecaka (BACKPACK) wpadłaby saszetka (CB) tego samego modelu.
          if (needAutoColors && apSizeToken === currentSizeToken && !isAlreadyManualColor) {
            if (!products.some(p => p.handle === ap.handle)) {
              products.push({ ...ap, is_auto_color: true });
            }
          }
        }
      }

      // Naprawiamy URLe (jeśli nie-domyślny język)
      const localeRoot = window.Shopify.routes.root;
      if (localeRoot !== '/') {
        products = products.map(p => {
          if (p.url && p.url.startsWith('/') && !p.url.startsWith(localeRoot)) p.url = localeRoot + p.url.substring(1);
          return p;
        });
      }

      // Odrzucamy duplikaty po Handle
      const uniqueHandles = {};
      products = products.filter(p => {
        if (!p.handle) return false;
        if (uniqueHandles[p.handle]) {
          console.warn(`[Linked Variants] DUPLICATE HANDLE DROPPED: ${p.handle}`);
          return false;
        }
        uniqueHandles[p.handle] = true;
        return true;
      });

      console.log(`[Linked Variants] FINAL: ${products.length} products`, products);

      if (products.length > 1) {
        this.renderVariants(products);
        const nativePicker = document.querySelector('variant-selects');
        if (nativePicker) nativePicker.style.display = 'none';
      } else {
        console.log('[Linked Variants] Only 1 product. Showing native fallback.');
        this.style.display = 'none';
        const nativePicker = document.querySelector('variant-selects');
        if (nativePicker) nativePicker.style.display = 'block';
      }
    } catch (error) {
      console.error('Error fetching linked variants:', error);
      const nativePicker = document.querySelector('variant-selects');
      if (nativePicker) {
        nativePicker.style.display = 'block';
      }
    }
  }

  renderVariants(products) {
    this.i18n = this.readSizeDropdownI18n();

    // Odfiltruj i posortuj produkty. Każdy produkt traktujemy jako wariant o unikalnym rozmiarze/kolorze
    
    // Zbuduj unikalne listy opcji:
    const colors = new Map(); // key: color_code, value: data
    const sizesForCurrentColor = []; // Lista rozmiarów dla aktualnie wybranego koloru
    let currentColorCode = null;
    let currentColorName = null;

    // Typ/rozmiar bieżącego produktu (np. "M", "BACKPACK"). Używamy go jako ostatecznej bramki:
    //  - KOLORY pokazujemy tylko dla TEGO SAMEGO typu w innej barwie (plecak nie pokaże saszetki CB),
    //  - KOMPLETY (KPL/SET) z auto-fetch pomijamy w selektorze rozmiaru pojedynczego produktu.
    // Produkty z `powiazane_rozmiary` dzięki `is_manual_size` zawsze trafiają do dropdownu.
    const currentP = products.find(p => p.handle === this.currentHandle) || products.find(p => p.is_current);
    const currentSizeToken = currentP ? String(currentP.size).toUpperCase().trim() : null;
    const currentIsSet = currentP ? this.isSet(currentP.size) : false;

    products.forEach(p => {
      // Pomijamy produkty innego typu/rozmiaru niż bieżący (np. saszetka CB przy plecaku BACKPACK),
      // żeby nie tworzyły fałszywych kafelków koloru.
      if (currentSizeToken && String(p.size).toUpperCase().trim() !== currentSizeToken) return;

      let cCode = p.color_code || p.color;
      let cName = p.color_name || p.color;

      // Fallback jeśli ktoś nie wypełnił ani SKU ze znacznikami ani metafielda
      if (!cCode || cCode.trim() === '') {
        cCode = p.handle || p.title;
        cName = p.title;
      }
      
      // Jeśli to jest aktualny produkt na którym jesteśmy, zapiszmy jego kolor
      if (p.handle === this.currentHandle) {
        currentColorCode = cCode;
        currentColorName = cName;
      }
      
      if (cCode && !colors.has(cCode)) {
        colors.set(cCode, { url: p.url, image: p.image, handle: p.handle, available: p.available, name: cName });
      }
    });

    // Jeśli nie wyłapaliśmy currentColorCode, fallback na wyrysowanie wszystkich rozmiarów dla byle jakiego koloru
    if (!currentColorCode && colors.size > 0) {
      currentColorCode = Array.from(colors.keys())[0];
      currentColorName = colors.get(currentColorCode).name;
    }
    
    console.log(`[Linked Variants] ACTIVE GROUPING: currentColorCode=${currentColorCode} | currentColorName=${currentColorName}`);

    // Znajdźmy rozmiary w tym konkretnym kolorze `currentColorCode` (lub wymuszone ręcznie z pominięciem filtra kolorów)
    products.forEach(p => {
      // Komplet z auto-fetch pomijamy w dropdownie pojedynczej walizki (chyba że jesteśmy na stronie kompletu).
      // Zestawy z `powiazane_rozmiary` (`is_manual_size`) zawsze pokazujemy.
      if (this.isSet(p.size) && !currentIsSet && !p.is_manual_size) return;
      const cCode = p.color_code || p.color;
      if ((cCode === currentColorCode && p.size) || p.is_manual_size) {
        console.log(`[Linked Variants] + ADDED TO DROPDOWN -> SKU: ${p.sku} | cCode: ${cCode} | JSON Size: '${p.size}' | Title: '${p.title}' | IsManual: ${!!p.is_manual_size}`);
        sizesForCurrentColor.push({
          size: p.size,
          sizeLabel: p.size_label || p.size,
          sizeSubtitle: p.size_subtitle,
          sizeIcon: p.size_icon,
          sizeDimensions: p.size_dimensions,
          sizeVolume: p.size_volume,
          url: p.url,
          handle: p.handle,
          available: p.available,
          title: p.title,
          variant_title: p.variant_title || ''
        });
      } else {
        console.log(`[Linked Variants] - REJECTED -> SKU: ${p.sku} | cCode: ${cCode} | Title: '${p.title}' (Mismatch with ${currentColorCode})`);
      }
    });

    // Sortowanie według ustalonej kolejności
    const orderSizes = ['16', '18', 'XS', '20', 'S', '24', 'M', '28', 'L', '32', 'XL', 'SET3', 'SET4', 'SET', '3KPL', '4KPL16'];
    sizesForCurrentColor.sort((a, b) => {
      const indexA = orderSizes.indexOf(String(a.size).toUpperCase());
      const indexB = orderSizes.indexOf(String(b.size).toUpperCase());
      
      if (indexA === -1 && indexB === -1) return 0; // Both not in order, maintain original order
      if (indexA === -1) return 1; // A not in order, B is, so B comes first
      if (indexB === -1) return -1; // B not in order, A is, so A comes first
      
      return indexA - indexB;
    });

    let html = '';

    // ======= RENDER SIZES (Rozmiary jako dropdown - style Wings) =======
    let shouldRenderSizes = sizesForCurrentColor.length > 0;
    if (sizesForCurrentColor.length === 1) {
      const sCode = String(sizesForCurrentColor[0].size).toUpperCase();
      if (sCode === 'ONE_SIZE' || sCode === 'OS' || !sCode) {
        shouldRenderSizes = false;
      }
    }
    if (this.autoSizesEnabled === false) {
      shouldRenderSizes = false;
    }

    if (shouldRenderSizes) {
      // Znajdź wybraną opcję rozmiaru
      const currentSizeObj = sizesForCurrentColor.find(s => s.handle === this.currentHandle) || sizesForCurrentColor[0];
      const currentTitleOverride = (currentSizeObj.variant_title || '').trim();
      const currentDisplayTitle = currentTitleOverride || this.sizeTitleForCode(currentSizeObj.size);

      // Bez defaultów: tylko metapola z podpiętych produktów
      let currentSub = currentSizeObj.sizeSubtitle || '';
      let cDim = currentSizeObj.sizeDimensions || '';
      let cVol = currentSizeObj.sizeVolume || '';
      
      if (this.isSet(currentSizeObj.size) && !currentSizeObj.sizeSubtitle) {
        currentSub = currentSizeObj.title ? currentSizeObj.title.split(/Wings/i)[0].trim() : 'Zestaw walizek';
      }

      html += `
        <div class="product-form__input product-variant-size-dropdown" data-size-dropdown>
          <div class="product-variant-size-dropdown__header">
            <span class="product-variant-size-dropdown__label">${this.i18n.label_size || 'Rozmiar'}</span>
          </div>
          <div class="product-variant-size-dropdown__wrap">
            <button type="button" class="product-variant-size-dropdown__trigger" aria-expanded="false" aria-haspopup="listbox" data-size-dropdown-trigger style="${sizesForCurrentColor.length <= 1 ? 'pointer-events: none;' : ''}">
              <div class="product-variant-size-dropdown__trigger-left">
                ${currentSizeObj.sizeIcon 
                  ? '<img src="' + currentSizeObj.sizeIcon + '" class="product-variant-size-dropdown__icon" style="width:24px; height:24px; object-fit:contain; margin-right:12px;">' 
                  : '<span class="product-variant-size-dropdown__badge">' + this.getBadgeText(currentSizeObj.size) + '</span>'}
                <div class="product-variant-size-dropdown__trigger-text">
                  <span class="product-variant-size-dropdown__trigger-title">${currentDisplayTitle}</span>
                  ${currentSub ? '<span class="product-variant-size-dropdown__trigger-subtitle">' + currentSub + '</span>' : ''}
                </div>
              </div>
              <div style="display: flex; align-items: center; margin-left: auto;">
                <div class="product-variant-size-dropdown__trigger-right" style="text-align: right; margin-right: 8px;">
                  ${cDim ? '<span class="product-variant-size-dropdown__trigger-dimensions" style="display:block; font-size:10px; font-weight:700; color:#111;">' + cDim + '</span>' : ''}
                  ${cVol ? '<span class="product-variant-size-dropdown__trigger-volume" style="font-size:10px; color:#9ca3af;">' + cVol + '</span>' : ''}
                </div>
                ${sizesForCurrentColor.length > 1 ? '<svg class="product-variant-size-dropdown__chevron" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg>' : ''}
              </div>
            </button>
            <div class="product-variant-size-dropdown__panel" data-size-dropdown-panel role="listbox">
              ${sizesForCurrentColor.map((s, idx) => {
                // Bez defaultów: tylko metapola z podpiętych produktów
                const opSub = s.sizeSubtitle || (this.isSet(s.size) ? (s.title ? s.title.split(/Wings/i)[0].trim() : 'Zestaw walizek') : '');
                const opDim = s.sizeDimensions || '';
                const opVol = s.sizeVolume || '';
                const titleOverride = (s.variant_title || '').trim();
                const displayTitle = titleOverride || this.sizeTitleForCode(s.size);
                
                return `
                <a href="${s.url}" class="product-variant-size-dropdown__option ${s.handle === this.currentHandle ? 'product-variant-size-dropdown__option--selected' : ''} ${!s.available ? 'product-variant-size-dropdown__option--disabled' : ''}" role="option" style="text-decoration: none;">
                  <div class="product-variant-size-dropdown__option-left">
                    ${s.sizeIcon 
                      ? '<img src="' + s.sizeIcon + '" class="product-variant-size-dropdown__icon" style="width:24px; height:24px; object-fit:contain; margin-right:12px;">' 
                      : '<span class="product-variant-size-dropdown__option-badge">' + this.getBadgeText(s.size) + '</span>'}
                    <div class="product-variant-size-dropdown__option-text">
                      <span class="product-variant-size-dropdown__option-title">${displayTitle}</span>
                      ${opSub ? '<span class="product-variant-size-dropdown__option-subtitle">' + opSub + '</span>' : ''}
                    </div>
                  </div>
                  ${opDim || opVol ? `
                  <div class="product-variant-size-dropdown__option-right" style="text-align: right;">
                    ${opDim ? '<span class="product-variant-size-dropdown__option-dimensions" style="display:block; font-size:10px; font-weight:700; color:#6b7280;">' + opDim + '</span>' : ''}
                    ${opVol ? '<span class="product-variant-size-dropdown__option-volume" style="font-size:9px; color:#d1d5db;">' + opVol + '</span>' : ''}
                  </div>
                  ` : ''}
                </a>
                `;
              }).join('')}
            </div>
          </div>
        </div>
      `;
    }

    // ======= RENDER COLORS (Kolory jako swatches - style Wings) =======
    if (colors.size > 0) {
      let availableColorsCount = 0;
      Array.from(colors.values()).forEach(c => {
        if (c.available) availableColorsCount++;
      });
      
      html += `
        <fieldset class="js product-form__input product-variant-cards">
          <legend class="visually-hidden">${this.i18n.label_color || 'Kolor'}</legend>
          <div class="product-variant-cards__header">
            <span class="product-variant-cards__label">${this.i18n.label_color || 'Kolor'}: <span class="product-variant-cards__selected" data-selected-value>${currentColorName}</span></span>
          </div>
          <div class="product-variant-cards__grid-wrap" data-color-cards-wrap>
          <button type="button" class="product-variant-cards__nav product-variant-cards__nav--prev" data-color-scroll="prev" aria-label="Przewiń w lewo">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M14 6l-6 6 6 6"/></svg>
          </button>
          <div class="product-variant-cards__grid" data-color-scroller>
      `;
      
      Array.from(colors.entries()).forEach(([colorCode, colorData], idx) => {
        const isSelected = colorCode === currentColorCode;
        const isDisabled = !colorData.available;
        
        // Ukryj kolory, których nie ma na stanie (nie dotyczy wariantu, na którym aktualnie jesteśmy)
        if (isDisabled && !isSelected) {
          return;
        }

        const inputId = `linked-color-${idx}`;
        const displayName = colorData.name || colorCode;
        
        // Render identical HTML to the product-variant-cards snippet
        html += `
          <div class="product-variant-cards__item">
            <input
              type="radio"
              id="${inputId}"
              name="linked-color-option"
              value="${colorCode}"
              ${isSelected ? 'checked' : ''}
              class="product-variant-cards__input visually-hidden ${isDisabled ? 'disabled' : ''}"
            >
            <label for="${inputId}" class="product-variant-cards__btn ${isDisabled ? 'product-variant-cards__btn--disabled' : ''} ${isSelected ? 'is-active' : ''}" title="${displayName}" onclick="window.location.href='${colorData.url}'" style="cursor:pointer">
              ${colorData.image 
                ? '<img src="' + colorData.image + '" alt="' + displayName + '" class="product-variant-cards__img" loading="lazy" width="200">' 
                : '<span class="product-variant-cards__img product-variant-cards__img--placeholder">' + displayName + '</span>'}
            </label>
          </div>
        `;
      });
      
      html += `
          </div>
          <button type="button" class="product-variant-cards__nav product-variant-cards__nav--next" data-color-scroll="next" aria-label="Przewiń w prawo">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M10 6l6 6-6 6"/></svg>
          </button>
          </div>
        </fieldset>
      `;
    }

    this.container.innerHTML = html;

    // Pokaż komponent (ukryty domyślnie w Liquid aby uniknąć mrugania)
    this.style.display = 'block';

    // Inicjalizacja dropdowna rozmiaru
    this.initDropdowns();

    // Inicjalizacja scrolla kolorów
    this.initColorScroll();
  }

  initColorScroll() {
    const wrap = this.container.querySelector('[data-color-cards-wrap]');
    if (!wrap) return;
    const scroller = wrap.querySelector('[data-color-scroller]');
    const prev = wrap.querySelector('[data-color-scroll="prev"]');
    const next = wrap.querySelector('[data-color-scroll="next"]');
    if (!scroller || !prev || !next) return;
    const step = () => Math.max(120, scroller.clientWidth * 0.6);
    const update = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      if (max <= 1) { prev.hidden = true; next.hidden = true; return; }
      prev.hidden = false; next.hidden = false;
      prev.classList.toggle('is-disabled', scroller.scrollLeft <= 1);
      next.classList.toggle('is-disabled', scroller.scrollLeft >= max - 1);
    };
    prev.addEventListener('click', () => scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => scroller.scrollBy({ left: step(), behavior: 'smooth' }));
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  
  initDropdowns() {
    const trigger = this.container.querySelector('[data-size-dropdown-trigger]');
    const panel = this.container.querySelector('[data-size-dropdown-panel]');
    
    if (trigger && panel) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', !isExpanded);
      });
      
      // Close when clicking outside
      document.addEventListener('click', (e) => {
        if (!this.container.contains(e.target) && trigger.getAttribute('aria-expanded') === 'true') {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }
}

customElements.define('linked-product-variants', LinkedProductVariants);